<template>
	<el-card shadow="never" class="aui-card--fill">
		<el-row style="background-color: #F3F4F4;">
			<el-col :xs="24" :md="3" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;">
				<img style="width: 16px;height: 16px;margin-right: 12px;" src="../../../assets/img/user-list.png" />
				任务列表
			</el-col>
			<el-col :xs="24" :md="3" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;">
				<el-select style="width: 95%;" v-model="dataForm.taskListType" placeholder="全部任务列表" @change="getvalue">
					<el-option v-for="item in jiesuan" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled"></el-option>
				</el-select>
			</el-col>
			<el-col :xs="24" :md="18">
				<el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" style="text-align: right;">
					<el-form-item>
						<el-button v-if="$hasPermission('plat:plattask:save')" type="primary" @click="childHandle()">发布新任务</el-button>
					</el-form-item>
					<el-form-item>
						<el-button class="exportBtn" style="left: 615px;" v-if="$hasPermission('plat:plattask:export')" type="info" @click="exportHandle()">
							{{ $t('export') }}
						</el-button>
					</el-form-item>
					<el-form-item><el-button class="refreshBtn" style="left: 500px;" type="info" @click="getDataList()">刷新</el-button></el-form-item>
					<el-form-item>
						<el-button class="delBtn" style="left: 760px;" v-if="$hasPermission('plat:plattask:delete')" type="danger" @click="deleteHandle()">
							{{ $t('deleteBatch') }}
						</el-button>
					</el-form-item>
				</el-form>
			</el-col>
		</el-row>

		<!-- 任务状态页签 -->
		<!-- <div class="conTab" v-if="isTab">
			<el-tabs v-model="activeName" @tab-click="handleClick">
				<el-tab-pane v-for="item in optionsvalue" :key="item.value" :label="item.label" :name="item.value"></el-tab-pane>
			</el-tabs>
		</div>	 -->

		<div class="mod-plat__plattask}">
			<el-form label-width="100px"  style="padding:10px 5px 0px;" ref="dataForm" :model="dataForm" @keyup.enter.native="getDataList()">
				<el-row>
					<el-col :md="12" :lg="6">
						<el-form-item label="任务申请编号:" prop="taskCode">
							<el-input style="width: 100%;" v-model="dataForm.taskCode" placeholder="任务申请编号" clearable></el-input>
						</el-form-item>
					</el-col>

					<el-col :md="12" :lg="8">
						<el-form-item label="预算金额:" prop="money1">
							<el-input v-model="dataForm.money1" placeholder="预算金额" style="width:48%"></el-input>
							<span style="width:4%;text-align: center;display: inline-block;">~</span>
							<el-input v-model="dataForm.money2" placeholder="预算金额" style="width: 48%"></el-input>
						</el-form-item>

					</el-col>
					<el-col :md="12" :lg="5">
						<el-form-item label="合同类别:" prop="contractType">
							<ren-select style="width: 100%;"  v-model="dataForm.contractType" dict-type="contractType"></ren-select>
						</el-form-item>
					</el-col>
					<el-col :md="12" :lg="5">
						<el-form-item label="发布方:" prop="publishName">
							<el-input style="width: 100%;" v-model="dataForm.publishName" placeholder="发布方" clearable></el-input></el-form-item>
					</el-col>
					</el-row>
				<el-row>
          <el-col :sm="6" :lg="6">
						<el-form-item label="任务状态:" prop="taskCategory">
							<el-select style="width: 100%;" v-model="dataForm.taskCategory" @change="handleClick" :disabled="dataForm.taskListType!=''&&dataForm.taskListType!='qb'" placeholder="任务状态" clearable filterable>
								<el-option v-for="item in optionsvalue" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled"></el-option>
							</el-select>

						</el-form-item>
					</el-col>
					<el-col :sm="8" :lg="8">
						<el-form-item class="pickerStyle" label="发布时间">
							<el-date-picker style="width:48%" :picker-options='pickerStartOptions(dataForm.endDate)' v-model="dataForm.startDate" placeholder="开始时间" type="date" @change="formatStartTime" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
							<span style="width:4%;text-align: center;display: inline-block;">~</span>
							<el-date-picker style="width:48%" v-model="dataForm.endDate" :picker-options='pickerEndOptions(dataForm.startDate)' placeholder="结束时间"  type="date" @change="formatEndTime" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :sm="10" :lg="10">
						<el-form-item>
							<div style="text-align: right;width: 100%">
								<el-button type="primary" @click="getDataList()">{{ $t('query') }}</el-button>
								<el-button class="refreshBtn" type="info" @click="resetForm('dataForm')">重置</el-button>
							</div>
						</el-form-item>

					</el-col>
				</el-row>
			</el-form>
			<el-table v-loading="dataListLoading" :data="dataList" @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
				<el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
				<el-table-column label="序号" type="index" width="50" align="center">
					<template slot-scope="scope">
						<span>{{ (page - 1) * limit + scope.$index + 1 }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="taskCode" label="任务发布编号" header-align="center" align="center" show-overflow-tooltip></el-table-column>

				<!--<el-table-column prop="taskDesc" label="任务简述" header-align="center" align="center" show-overflow-tooltip></el-table-column>-->
				<!-- <el-table-column prop="taskRequire" label="结算价格及结算方式" header-align="center" align="center" show-overflow-tooltip></el-table-column> -->
				<el-table-column prop="publishName" label="发布方" header-align="center" align="center" show-overflow-tooltip></el-table-column>

				<el-table-column prop="secondBody" label="接受方" header-align="center" align="center"></el-table-column>
				<el-table-column prop="contractCode" label="关联合同编号" header-align="center" align="center">
					<template slot-scope="scope">
						<el-button style="word-break: break-all;white-space: wrap;" type="text" size="small" @click="contractinfoHandle(scope.row.contractId)">{{scope.row.contractCode}}</el-button>
					</template>
				</el-table-column>
				<el-table-column prop="taskType" label="任务大类" header-align="center" align="center">
					<template slot-scope="scope">
						{{ $getDictLabel('taskType', scope.row.taskType) }}
					</template>
				</el-table-column>

				<el-table-column prop="requirePerson" label="需求人数" header-align="center" align="center"></el-table-column>

				<el-table-column prop="allotNum" label="被分配人数" header-align="center" align="center"></el-table-column>
				<el-table-column prop="acceptNum" label="已接受人数" header-align="center" align="center"></el-table-column>
				<el-table-column prop="finishNum" label="已完成人数" header-align="center" align="center"></el-table-column>
				<!-- <el-table-column prop="budget" label="预算金额(元)" header-align="center" align="center"></el-table-column>
				<el-table-column prop="bz" label="币种" header-align="center" align="center">人民币</el-table-column> -->
				<!-- 任务中心—任务列表“操作时间”改为“发布时间” -->
			<el-table-column
					prop="createDate"
					label="发布时间"
					header-align="center"
					align="center"
					type="datetime"
					format="yyyy-MM-dd"
					show-overflow-tooltip
				></el-table-column>

				<el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
					<template slot-scope="scope">
						<el-tooltip class="item" effect="dark" content="只有草稿状态才可修改。如已提交发布，请先进行驳回操作！" placement="left">
							<span>
								<el-button
									v-if="$hasPermission('plat:plattask:update')"
									:disabled="scope.row.status != 0"
									type="text"
									size="small"
									@click="childHandle(scope.row.id)"
								>
									{{ $t('update') }}
								</el-button>
							</span>
						</el-tooltip>
						<el-tooltip class="item" effect="dark" content="只有草稿状态才可删除。如已提交发布，请先进行驳回操作！" placement="left">
							<span>
								<el-button
									v-if="$hasPermission('plat:plattask:delete')"
									:disabled="scope.row.status != 0"
									type="text"
									size="small"
									@click="deleteHandle(scope.row.id)"
								>
									{{ $t('delete') }}
								</el-button>
							</span>
						</el-tooltip>
						<el-tooltip class="item" v-if="scope.row.status < 2" effect="dark" content="在详情页面中进行审核！" placement="left">
							<el-button type="text" size="small" @click="infoHandle(scope.row.id)">详情</el-button>
						</el-tooltip>
						<el-tooltip class="item" v-else effect="dark" content="查看详情" placement="left">
							<el-button type="text" size="small" @click="infoHandle(scope.row.id)">详情</el-button>
						</el-tooltip>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				background
				:current-page="page"
				:page-sizes="[10, 20, 50, 100]"
				:page-size="limit"
				:total="total"
				layout="total, sizes, prev, pager, next, jumper"
				@size-change="pageSizeChangeHandle"
				@current-change="pageCurrentChangeHandle"
			></el-pagination>
			<!-- 弹窗, 新增 / 修改 -->
			<add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
			<deputy-info v-if="deputyInfoVisible" ref="deputyInfo" @refreshDataList="getDataList"></deputy-info>
		</div>
	</el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './plattask-add-or-update'
import DeputyInfo from './plattask-info'
import { addDynamicRoute } from '@/router'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
		pickerStartOptions(endTime){
                return {
                    disabledDate(time){
                        if(endTime){
                        // 拼接 00:00:00 是为了统一日期从0点开始 
                        return time.getTime() > new Date(endTime +' 00:00:00').getTime();
                        }
                    }
                } 
            },
            pickerEndOptions(startTime){
                return {
                    disabledDate(time){
                        if(startTime){
                        // 拼接 00:00:00 是为了统一日期从0点开始 
                        return time.getTime() < new Date(startTime +' 00:00:00').getTime();
                        }
                    }
                }
            },
		isTab:true,
		activeName:'sh',
      deputyInfoVisible: false,
      mixinViewModuleOptions: {
        getDataListURL: '/sys/plat/task/page',
        getDataListIsPage: true,
        deleteURL: '/sys/plat/task',
        deleteIsBatch: true,
        exportURL: '/sys/plat/task/export2'
      },
      
      jiesuan: [
		{
          value: 'qb',
          label: '全部任务'
        },
        {
          value: 'tj',
          label: '已发布任务列表'
        },
        {
          value: 'sh',
          label: '平台接受任务列表'
        },
        {
          value: 'fp',
          label: '对外分包任务列表'
        },
        {
          value: 'js',
          label: '个人已接收任务列表'
        },
        {
          value: 'wc',
          label: '已完成任务列表'
        }
      ],

      optionsvalue: [
        {
          value: 'cg',
          label: '草稿'
        },
        {
          value: 'tj',
          label: '已提交'
        },
        {
          value: 'sh',
          label: '已审核'
        },
        {
          value: 'fp',
          label: '已分配'
        },
        {
          value: 'js',
          label: '已接受'
        },
        {
          value: 'wc',
          label: '已完成'
        }
      ],
      dataForm: {
        taskCode: '',
        contractCode: '',
		taskType: '',
		publishName:'',
        contractType: '',
        taskCategory: '', // 任务状态
        money1: '',
        money2: '',
        startDate: '',
		endDate: '',
		taskListType: 'qb'
	  },
      daterange: null,
      options: []
    }
  },
  components: {
    AddOrUpdate,
    DeputyInfo
  },
  watch: {
    daterange (val) {
      if (val !== null) {
        this.dataForm.startDate = val[0]
        this.dataForm.endDate = val[1]
      } else {
        this.dataForm.startDate = ''
        this.dataForm.endDate = ''
      }
    }
  },
  created () {
    this.getContract()
  },
  methods: {
	handleClick(tab) {
		this.dataForm.taskCategory = tab
	  this.getDataList();
	},
    formatStartTime (val) {
		  this.dataForm.startDate = val
    },
    formatEndTime (val) {
		  this.dataForm.endDate = val
    },
    getContract () {
      this.$http
        .get(`/sys/plat/contract/getContractCodeList`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.options = res.data
        })
        .catch(() => {})
    },
    // 查看
    infoHandle (id) {
      localStorage.setItem(this.$route.name,JSON.stringify(this.dataForm))

      // 路由参数
      const routeParams = {
        routeName: `${this.$route.name}__任务详情`,
        title: `任务详情`,
        path: 'plat/platttask-info',
        params: {
          id: id
        }
      }
      // 动态路由
      addDynamicRoute(routeParams, this.$router)
    },
    childHandle (id = 0) {
		  // 路由参数
		  const routeParams = {
        routeName: `${this.$route.name}__任务信息`,
        title: `任务信息`,
        path: 'plat/platttask-add',
        params: {
			  id: id
        }
		  }
		  // 动态路由
		  addDynamicRoute(routeParams, this.$router)
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
      this.dataForm.money2 = ''
      this.dataForm.startDate = ''
      this.dataForm.endDate = ''
	  this.getDataList();
    },
    getvalue () {
		if(this.dataForm.taskListType!='qb'){
			this.isTab = false;
			this.dataForm.taskCategory=''
		}else{
			this.isTab = true;
			this.dataForm.taskCode=''
			this.dataForm.publishName=''
			this.dataForm.contractCode=''
			this.dataForm.taskType=''
			this.dataForm.contractType=''
			this.dataForm.taskCategory=''
			this.dataForm.money1=''
			this.dataForm.money2=''
			this.dataForm.startDate=''
			this.dataForm.endDate=''
		}
      	this.getDataList()
    },
    // 查看
    contractinfoHandle (id) {
      // 路由参数
      const routeParams = {
        routeName: `${this.$route.name}__合同详情`,
        title: `合同详情`,
        path: 'plat/platcontract-info',
        params: {
						  id: id
        }
      }
      // 动态路由
      addDynamicRoute(routeParams, this.$router)
    }
  }
}
</script>
<style>
.conTab{
	border-bottom:20px solid rgb(243, 244, 244);
	padding-bottom: 0 !important;
}
.el-tabs__item{
	width: auto !important;
	padding:0 20px !important
}
.el-tabs__header{
	margin:0 !important;
}
.item {
	margin: 4px;
}
.el-button{
		white-space:normal;
	}
</style>
